import { createAction, props } from '@ngrx/store';
import { PackingList } from '../models/packing-list.model';

export const loadPackingLists = createAction('[Packing Lists] Load Packing Lists');

export const loadPackingListsSuccess = createAction(
  '[Packing Lists] Load Packing Lists Success',
  props<{ packingLists: PackingList[] }>()
);

export const loadPackingListsFailure = createAction(
  '[Packing Lists] Load Packing Lists Failure',
  props<{ error: string }>()
);

export const loadPackingList = createAction(
  '[Packing Lists] Load Packing List',
  props<{ listId: string }>()
);

export const loadPackingListSuccess = createAction(
  '[Packing Lists] Load Packing List Success',
  props<{ packingList: PackingList }>()
);

export const loadPackingListFailure = createAction(
  '[Packing Lists] Load Packing List Failure',
  props<{ error: string }>()
);

export const createPackingList = createAction(
  '[Packing Lists] Create Packing List',
  props<{ name: string }>()
);

export const createPackingListSuccess = createAction(
  '[Packing Lists] Create Packing List Success',
  props<{ packingList: PackingList }>()
);

export const createPackingListFailure = createAction(
  '[Packing Lists] Create Packing List Failure',
  props<{ error: string }>()
);

export const renamePackingList = createAction(
  '[Packing Lists] Rename Packing List',
  props<{ listId: string; name: string }>()
);

export const renamePackingListSuccess = createAction(
  '[Packing Lists] Rename Packing List Success',
  props<{ packingList: PackingList }>()
);

export const renamePackingListFailure = createAction(
  '[Packing Lists] Rename Packing List Failure',
  props<{ error: string }>()
);

export const deletePackingList = createAction(
  '[Packing Lists] Delete Packing List',
  props<{ listId: string }>()
);

export const deletePackingListSuccess = createAction(
  '[Packing Lists] Delete Packing List Success',
  props<{ listId: string }>()
);

export const deletePackingListFailure = createAction(
  '[Packing Lists] Delete Packing List Failure',
  props<{ error: string }>()
);

export const addPackingListItem = createAction(
  '[Packing Lists] Add Packing List Item',
  props<{ listId: string; label: string }>()
);

export const addPackingListItemSuccess = createAction(
  '[Packing Lists] Add Packing List Item Success',
  props<{ packingList: PackingList }>()
);

export const addPackingListItemFailure = createAction(
  '[Packing Lists] Add Packing List Item Failure',
  props<{ listId: string; error: string }>()
);

export const togglePackingListItem = createAction(
  '[Packing Lists] Toggle Packing List Item',
  props<{ listId: string; itemId: string }>()
);

export const renamePackingListItem = createAction(
  '[Packing Lists] Rename Packing List Item',
  props<{ listId: string; itemId: string; label: string }>()
);

export const togglePackingListItemSuccess = createAction(
  '[Packing Lists] Toggle Packing List Item Success',
  props<{ packingList: PackingList }>()
);

export const renamePackingListItemSuccess = createAction(
  '[Packing Lists] Rename Packing List Item Success',
  props<{ packingList: PackingList }>()
);

export const togglePackingListItemFailure = createAction(
  '[Packing Lists] Toggle Packing List Item Failure',
  props<{ error: string }>()
);

export const renamePackingListItemFailure = createAction(
  '[Packing Lists] Rename Packing List Item Failure',
  props<{ error: string }>()
);

export const deletePackingListItem = createAction(
  '[Packing Lists] Delete Packing List Item',
  props<{ listId: string; itemId: string }>()
);

export const bulkDeletePackingListItems = createAction(
  '[Packing Lists] Bulk Delete Packing List Items',
  props<{ listId: string; itemIds: string[] }>()
);

export const reorderPackingListItems = createAction(
  '[Packing Lists] Reorder Packing List Items',
  props<{ listId: string; itemIds: string[] }>()
);

export const deletePackingListItemSuccess = createAction(
  '[Packing Lists] Delete Packing List Item Success',
  props<{ packingList: PackingList }>()
);

export const bulkDeletePackingListItemsSuccess = createAction(
  '[Packing Lists] Bulk Delete Packing List Items Success',
  props<{ packingList: PackingList }>()
);

export const reorderPackingListItemsSuccess = createAction(
  '[Packing Lists] Reorder Packing List Items Success',
  props<{ packingList: PackingList }>()
);

export const deletePackingListItemFailure = createAction(
  '[Packing Lists] Delete Packing List Item Failure',
  props<{ error: string }>()
);

export const bulkDeletePackingListItemsFailure = createAction(
  '[Packing Lists] Bulk Delete Packing List Items Failure',
  props<{ error: string }>()
);

export const reorderPackingListItemsFailure = createAction(
  '[Packing Lists] Reorder Packing List Items Failure',
  props<{ error: string }>()
);
